// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.CodeInput-module__Group__jSQPr {
    display: flex;
    gap: var(--ds-s);
}

.CodeInput-module__Container__6i7vI {
    width: auto;
}

.CodeInput-module__Input__hB7OG {
    width: var(--ds-9x);
    padding-right: 0;
    padding-left: 0;
    text-align: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Group": `CodeInput-module__Group__jSQPr`,
	"Container": `CodeInput-module__Container__6i7vI`,
	"Input": `CodeInput-module__Input__hB7OG`
};
export default ___CSS_LOADER_EXPORT___;
